module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1600@2x-a90e8c76e1b2ef0b202427fb5167fc06.webp";